// Google Analytics 4 の初期化と設定
import ReactGA from 'react-ga4';
import axios from 'axios';

const MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;
const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://rangers-api-3mfw.onrender.com';

export const initGA = () => {
  if (MEASUREMENT_ID) {
    ReactGA.initialize(MEASUREMENT_ID);
    console.log('Google Analytics initialized');
  } else {
    console.warn(
      'Google Analytics Measurement ID is not set. ' +
      'Set REACT_APP_GA_MEASUREMENT_ID in your .env file.'
    );
  }
};

// ページビューを送信（GA + アクセスログAPI）
export const trackPageView = (path) => {
  // GAに送信
  if (MEASUREMENT_ID) {
    ReactGA.send({ hitType: 'pageview', page: path });
  }

  // アクセスログAPIにも送信
  const token = localStorage.getItem('authToken');
  if (token) {
    axios.post(`${API_BASE_URL}/api/access-logs/pageview`, {
      path: path,
      timestamp: new Date().toISOString()
    }, {
      headers: { Authorization: `Bearer ${token}` }
    }).catch(err => {
      // ログ記録失敗はサイレントに無視
      console.debug('Failed to log page view:', err.message);
    });
  }
};

// カスタムイベントを送信
export const trackEvent = (category, action, label) => {
  if (MEASUREMENT_ID) {
    ReactGA.event({
      category,
      action,
      label,
    });
  }
};
